import { createRouter, createWebHistory } from 'vue-router';
import Home from '../components/Home.vue';
import Login from '../components/Login.vue';
import BiDashboardApp from '../components/BiDashboardApp.vue';
import AiDashboardApp from '../components/AiDashboardApp.vue';
import DigitalTriplet from '../components/DigitalTriplet.vue';
import MarketanalyzerApp from '../components/MarketanalyzerApp.vue';
import ChatBotApp from '../components/ChatBotApp.vue';
import SharepointApp from '../components/SharepointApp.vue';
import Signup from '../components/Signup.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Login,
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/bi-dashboard',
    name: 'BiDashboardApp',
    component: BiDashboardApp,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/ai-dashboard',
    name: 'AiDashboardApp',
    component: AiDashboardApp,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/chatbot',
    redirect: '/digital-assistant',
  },
  {
    path: '/digital-assistant',
    name: 'ChatBotApp',
    component: ChatBotApp,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/sharepoint',
    name: 'SharepointApp',
    component: SharepointApp,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/digitaltriplet',
    name: 'DigitalTripletApp',
    component: DigitalTriplet,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/marketanalyzer',
    name: 'MarketAnalyzerApp',
    component: MarketanalyzerApp,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const isLoggedIn = localStorage.getItem('token');
    
    const CURRENT_BUILD = '2025-05-28';
    if (localStorage.getItem('build') !== CURRENT_BUILD) {
      localStorage.clear()
      localStorage.setItem('build', CURRENT_BUILD);
      next({ name: 'Login' });
    }

    if (!isLoggedIn) {
      next({ name: 'Login' });
    } else {
      next();
    }
  } else {
    next();
  }
});



export default router;